<div class="skeleton-strategy-details-container">
  <div class="strategy-header component">
    <skeleton-display-text size="large"></skeleton-display-text>
    <div class="strategy-header-tags">
      <skeleton-body-text class="skeleton-category"></skeleton-body-text>
      <div class="tags-list">
        <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
        <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
        <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
      </div>
    </div>
  </div>
  <div class="strategy-content">
    <div class="strategy-body">
      <div class="preview component">
        <skeleton-display-text size="medium"></skeleton-display-text>
        <skeleton-thumbnail size="medium"></skeleton-thumbnail>
      </div>
      <div class="concept component">
        <skeleton-display-text size="medium"></skeleton-display-text>
        <skeleton-paragraph [numOfLines]="6" lineHeight="medium"></skeleton-paragraph>
      </div>
    </div>

    <div class="strategy-details component">
      <skeleton-display-text size="medium"></skeleton-display-text>
      <div class="kpi">
        <skeleton-body-text class="skeleton-label"></skeleton-body-text>
        <skeleton-body-text class="skeleton-value"></skeleton-body-text>
      </div>
      <div class="complexity-win">
        <div class="complexity">
          <skeleton-body-text class="skeleton-label"></skeleton-body-text>
          <skeleton-body-text class="skeleton-value"></skeleton-body-text>
        </div>
        <div class="complexity win-rate">
          <skeleton-body-text class="skeleton-label"></skeleton-body-text>
          <skeleton-body-text class="skeleton-value"></skeleton-body-text>
        </div>
      </div>
      <pdq-divider></pdq-divider>
      <div class="tags">
        <skeleton-body-text class="skeleton-tags-title"></skeleton-body-text>
        <div class="tags-list">
          <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
          <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
          <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
        </div>
      </div>
    </div>
  </div>
</div>
